import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

interface ReportViewProps {
  title: string;
  loading: boolean;
  error: string | null;
  count: number | null;
  action?: ReactNode;
  children: ReactNode;
}

/** Shared shell for a report page: title (with an optional action), loading, error, row count, then the table (children). */
export const ReportView = (props: ReportViewProps) => {
  const { title, loading, error, count, action, children } = props;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 700 }}
        >
          {title}
        </Typography>
        {action}
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error">
          {error} — is the backend dev server running (`npm run dev`)?
        </Alert>
      )}

      {count !== null && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1 }}
        >
          {count} rows
        </Typography>
      )}

      {children}
    </Box>
  );
};
